import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import { LoaderComponent } from '@sharedModule/components/loader/loader.component';
import { LoaderService } from '@sharedModule/services/loader/loader.service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [CommonModule, RouterOutlet, LoaderComponent],
})
export class AppComponent implements  AfterContentChecked {
  constructor(
    public loaderService: LoaderService,
    private changeDetector: ChangeDetectorRef,
  ) {}

  title = 'Med-AI';
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
}
